module.exports = __webpack_public_path__ + "b9484b8fa2a43ac14dc9c57a2426df3a.svg";